module.exports = __webpack_public_path__ + "3416d973acf675935dc114e512f6797e.svg";